export const questions = [
    {
      "text": "他人を説得したり、交渉することに自信がありますか？",
      "categories": [
        "企業的",
        "社会的"
      ]
    },
    {
      "text": "規則正しい環境で作業するのが落ち着きますか？",
      "categories": [
        "慣習的"
      ]
    },
    {
      "text": "チームを率いて物事を進めることが得意ですか？",
      "categories": [
        "企業的"
      ]
    },
    {
      "text": "型にはまらない自由な発想を大切にしますか？",
      "categories": [
        "開放性"
      ]
    },
    {
      "text": "他人の意見を尊重して行動しますか？",
      "categories": [
        "協調性"
      ]
    },
    {
      "text": "イベントを企画したり、プロジェクトを管理するのが得意ですか？",
      "categories": [
        "企業的",
        "社会的"
      ]
    },
    {
      "text": "人々を元気づけたり、動機づけるのが得意ですか？",
      "categories": [
        "社会的",
        "企業的"
      ]
    },
    {
      "text": "グループ活動より1人での作業を好みますか？",
      "categories": [
        "外向性"
      ]
    },
    {
      "text": "新しいアイデアを考え出し、形にするのが好きですか？",
      "categories": [
        "芸術的",
        "企業的"
      ]
    },
    {
      "text": "定められたルールや手順に従って作業するのは得意ですか？",
      "categories": [
        "慣習的"
      ]
    },
    {
      "text": "芸術や文化に触れることが好きですか？",
      "categories": [
        "開放性"
      ]
    },
    {
      "text": "他人を助けたり、教えたりすることに喜びを感じますか？",
      "categories": [
        "社会的"
      ]
    },
    {
      "text": "物事を新しい形で表現するのは楽しいですか？",
      "categories": [
        "芸術的"
      ]
    },
    {
      "text": "人前で話すことに抵抗はありませんか？",
      "categories": [
        "外向性"
      ]
    },
    {
      "text": "自由な発想を活かせる職場で働きたいと思いますか？",
      "categories": [
        "芸術的",
        "企業的"
      ]
    },
    {
      "text": "新しいアイデアや挑戦に興味がありますか？",
      "categories": [
        "開放性"
      ]
    },
    {
      "text": "他人の感情や意見を理解し、共感することが得意ですか？",
      "categories": [
        "社会的"
      ]
    },
    {
      "text": "絵や音楽など、クリエイティブな活動に没頭することが好きですか？",
      "categories": [
        "芸術的"
      ]
    },
    {
      "text": "気持ちの浮き沈みは少ない方ですか？",
      "categories": [
        "情緒安定性"
      ]
    },
    {
      "text": "財務や経理の仕事に興味がありますか？",
      "categories": [
        "慣習的"
      ]
    },
    {
      "text": "工具や機械を使って作業することは好きですか？",
      "categories": [
        "現実的"
      ]
    },
    {
      "text": "数学や科学を使って問題を解決するのが得意ですか？",
      "categories": [
        "研究的"
      ]
    },
    {
      "text": "相手の立場になって考えることが得意ですか？",
      "categories": [
        "協調性"
      ]
    },
    {
      "text": "チームでの衝突はなるべく避けたいと考えますか？",
      "categories": [
        "協調性"
      ]
    },
    {
      "text": "プレッシャーがかかると不安になりやすいですか？",
      "categories": [
        "情緒安定性"
      ]
    },
    {
      "text": "自然の中で働くことに興味がありますか？",
      "categories": [
        "現実的",
        "社会的"
      ]
    },
    {
      "text": "物語や詩を書くのが好きですか？",
      "categories": [
        "芸術的"
      ]
    },
    {
      "text": "技術や科学の進歩を仕事に取り入れることに興味がありますか？",
      "categories": [
        "研究的",
        "現実的"
      ]
    },
    {
      "text": "トラブルが起きても冷静に対処できますか？",
      "categories": [
        "情緒安定性"
      ]
    },
    {
      "text": "困難な状況で他人を支える役割を果たしたいと思いますか？",
      "categories": [
        "社会的",
        "現実的"
      ]
    },
    {
      "text": "予算やデータを整理するのが得意だと感じますか？",
      "categories": [
        "慣習的",
        "研究的"
      ]
    },
    {
      "text": "一度決めたことは最後までやり抜く方ですか？",
      "categories": [
        "誠実性"
      ]
    },
    {
      "text": "自然や環境保護に関心がありますか？",
      "categories": [
        "現実的",
        "社会的"
      ]
    },
    {
      "text": "チームでの競争的な仕事に魅力を感じますか？",
      "categories": [
        "企業的",
        "現実的"
      ]
    },
    {
      "text": "細かいルールや手順もきちんと守る方ですか？",
      "categories": [
        "誠実性"
      ]
    },
    {
      "text": "詳細なデータを分析し、結論を出すのが得意ですか？",
      "categories": [
        "研究的",
        "慣習的"
      ]
    },
    {
      "text": "計画的に物事を進めるのが得意ですか？",
      "categories": [
        "誠実性"
      ]
    },
    {
      "text": "物事の原因や仕組みを深く理解するのが好きですか？",
      "categories": [
        "研究的"
      ]
    },
    {
      "text": "機械やテクノロジーを使った仕事に興味がありますか？",
      "categories": [
        "現実的",
        "研究的"
      ]
    },
    {
      "text": "初対面の人とも積極的に話す方ですか？",
      "categories": [
        "外向性"
      ]
    }
  ];
  
  export const categories = [
    "現実的",
    "研究的",
    "社会的",
    "芸術的",
    "企業的",
    "慣習的",
    "誠実性",
    "協調性",
    "情緒安定性",
    "外向性",
    "開放性"
  ];